// src/App.js

import { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Loader from './components/Loader';
import Header from './components/Header';
import FloatingRegisterButton from './components/FloatingRegisterButton';
import Hero from './components/Hero';
import TeachingStaff from './pages/TeachingStaff';
import FeeStructure from './pages/FeeStructure';
import PrincipalMessage from './pages/PrincipalMessage';
import DirectorMessage from './pages/DirectorMessage';
import AdmissionEnquiry from './pages/AdmissionEnquiry';
import JobEnquiry from './pages/JobEnquiry';
import ExamCorner from './pages/ExamCorner';
import UniformSchedule from './pages/UniformSchedule';
import AboutUs from './pages/AboutUs';
import Academics from './pages/Academics';
import TheSchool from './pages/TheSchool';
import Gallery from './pages/Gallery';
import ContactUs from './pages/ContactUs';
import MandatoryDisclosure from './pages/MandatoryDisclosure';
import Footer from './components/Footer';
import DesyncPromo from './components/DesyncPromo';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfServices';
import PaymentNotice from './components/PaymentNotice';
import ScanScoreArticle from './pages/ScanScoreArticle';
import ScanScorePromo from './components/ScanScorePromo';
import BlogList from './pages/BlogList';
import BlogPost from './pages/BlogPost';

function App() {
  const [isClientLoaded, setIsClientLoaded] = useState(false);

  // Show payment notice if enabled
  const SHOW_PAYMENT_NOTICE = false;
  
  useEffect(() => {
    setTimeout(() => {
      setIsClientLoaded(true);
    }, 1500);
  }, []);

  if (!isClientLoaded) {
    return <Loader />;
  }

  if (SHOW_PAYMENT_NOTICE) {
    return <PaymentNotice />;
  }

  return (
    <Router>
      <div className="App">
        <Header />
        <Routes>
          <Route path="/" element={<Hero />} />
          
          {/* 1. About Us & Subpages */}
          <Route path="/about-us" element={<AboutUs />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/principal-message" element={<PrincipalMessage />} />
          <Route path="/director-message" element={<DirectorMessage />} />
          <Route path="/mandatory-disclosure" element={<MandatoryDisclosure />} />
          
          {/* 2. Academics */}
          <Route path="/academics" element={<Academics />} />
          <Route path="/uniform-schedule" element={<UniformSchedule />} />
          <Route path="/dress-code" element={<UniformSchedule />} />
          <Route path="/exam-corner" element={<ExamCorner />} />
          
          {/* 3. The School */}
          <Route path="/the-school" element={<TheSchool />} />
          <Route path="/rules-and-regulations" element={<TheSchool />} />
          <Route path="/infrastructure" element={<TheSchool />} />
          <Route path="/teaching-staff" element={<TeachingStaff />} />
          
          {/* 4. Admission */}
          <Route path="/admission" element={<AdmissionEnquiry />} />
          <Route path="/admission-enquiry" element={<AdmissionEnquiry />} />
          
          {/* 5. Gallery */}
          <Route path="/gallery" element={<Gallery />} />
          
          {/* 6. Fee Structure */}
          <Route path="/fee-structure" element={<FeeStructure />} />
          
          {/* 7. Contact Us */}
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/contact" element={<ContactUs />} />
          
          {/* Educational Blogs & School Guides */}
          <Route path="/blog" element={<BlogList />} />
          <Route path="/blogs" element={<BlogList />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/blogs/:slug" element={<BlogPost />} />
          
          {/* Target Keyword Landing Routes */}
          <Route path="/no-1-private-school-in-goraul" element={<Hero />} />
          <Route path="/no-1-school-in-goraul" element={<Hero />} />
          <Route path="/no-1-school-near-goraul" element={<Hero />} />
          <Route path="/no-1-private-school-in-goraul-vaishali" element={<Hero />} />
          <Route path="/no-1-school-in-goraul-vaishali" element={<Hero />} />
          <Route path="/no-1-school-near-goraul-vaishali" element={<Hero />} />
          <Route path="/best-private-school-in-goraul" element={<Hero />} />
          <Route path="/best-school-in-goraul" element={<Hero />} />
          <Route path="/best-school-near-goraul" element={<Hero />} />
          <Route path="/best-private-school-in-goraul-vaishali" element={<Hero />} />
          <Route path="/best-school-in-goraul-vaishali" element={<Hero />} />
          <Route path="/best-school-near-goraul-vaishali" element={<Hero />} />
          
          {/* Smart Assessment with ScanScore */}
          <Route path="/scanscore-assessment" element={<ScanScoreArticle />} />
          <Route path="/scanscore" element={<ScanScoreArticle />} />
          <Route path="/powered-by-scanscore" element={<ScanScoreArticle />} />
          
          {/* Career & Legal */}
          <Route path="/job-enquiry" element={<JobEnquiry />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
        </Routes>
        <ScanScorePromo />
        <DesyncPromo />
        <Footer />
        <FloatingRegisterButton />
      </div>
    </Router>
  );
}

export default App;
